import React from 'react';
import { useBemCN } from '@gik/core/utils/bemBlock';
import Input, { InputProps } from '../Input';
import SvgIcon from '../SvgIcon';

export interface ISearchInputProps extends InputProps {}

export function SearchInput({
  className,
  onValueChange,
  variant = 'white',
  ...otherProps
}: ISearchInputProps): React.ReactElement {
  const bem = useBemCN('search-input');

  const [active, setActive] = React.useState<boolean>(false);
  const [value, setValue] = React.useState<string>();
  const valueRef = React.useRef<string>();
  valueRef.current = value;

  return (
    <Input
      pill
      placeholder="Search..."
      variant={variant}
      prepend={<SvgIcon {...bem('icon')} name="Search" onClick={() => setActive(!active)} />}
      onBlur={() => {
        if (!valueRef.current) setActive(false);
      }}
      onClear={() => setActive(false)}
      onFocus={() => setActive(true)}
      clearable
      active={active}
      value={value}
      {...otherProps}
      onValueChange={v => {
        setValue(v);
        onValueChange(v);
      }}
      {...bem(null, null, className)}
    />
  );
}
